// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mr-0";
export var discountCodeInput = "_mr-1";